export default "__VITE_ASSET__cCYZy_S9__"